/* EaseEase Saved & Compare v1
   - Heart on product cards + product page (quick save, no login)
   - On product pages, if the shopper has touched the Live Product Options widget,
     the heart saves the current selections too ("design")
   - /pages/saved: list, compare (2–4), "still deciding" help block
   - free-fabric-swatches: best-effort pre-select of swatches from the saved list
   Data lives in localStorage (this device only). */
(function () {
  'use strict';

  var CFG = window.EE_WISH || {};
  var KEY = 'ee_saved_v1';
  var SW_KEY = 'ee_sw_req';
  var MAX_ITEMS = 40;
  var MAX_CMP = 4;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.6-9.3-9.4C1.5 7.7 3.8 4.4 7.2 4.4c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.4 0 5.7 3.3 4.5 6.8-1.7 4.8-9.3 9.4-9.3 9.4z" stroke-linejoin="round"/></svg>';
  var HARDWARE_RE = /rod|track|rail|motoriz|hardware|installation|fee|sample|swatch/i;

  /* ---------------- utils ---------------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function root() { var r = CFG.root || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function waitFor(sel, timeout) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function poll() {
        var el = $(sel);
        if (el) return resolve(el);
        if (Date.now() - t0 > (timeout || 20000)) return resolve(null);
        setTimeout(poll, 250);
      })();
    });
  }

  /* ---------------- storage ---------------- */
  function load() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function store(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_ITEMS))); } catch (e) {}
    updateCount();
    syncHearts();
    document.dispatchEvent(new CustomEvent('ee:saved-change'));
  }
  function byHandle(h) { return load().filter(function (i) { return i.handle === h; }); }
  function addItem(item) {
    var list = load().filter(function (i) {
      if (i.handle !== item.handle) return true;
      if (i.sig === item.sig) return false;          // same design saved again
      if (item.sig && !i.sig) return false;          // a design replaces the plain save
      return true;
    });
    list.unshift(item);
    store(list);
    track('ee_saved_add', { handle: item.handle, configured: !!item.config });
  }
  function removeWhere(fn) {
    var list = load();
    var removed = list.filter(fn);
    store(list.filter(function (i) { return !fn(i); }));
    return removed;
  }
  function restoreItems(items) {
    var list = load();
    items.forEach(function (it) { if (!list.some(function (i) { return i.id === it.id; })) list.unshift(it); });
    store(list);
  }

  /* ---------------- header count + hearts ---------------- */
  function updateCount() {
    var n = load().length;
    $$('.ee-saved-count').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
  }
  function syncHearts() {
    var handles = {};
    load().forEach(function (i) { handles[i.handle] = true; });
    $$('[data-ee-heart]').forEach(function (b) {
      var on = !!handles[b.getAttribute('data-handle')];
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(html, actions) {
    var el = $('#ee-toast');
    if (!el) return;
    el.innerHTML = '<span class="ee-toast__msg">' + html + '</span>';
    (actions || []).forEach(function (a) {
      var n;
      if (a.href) { n = document.createElement('a'); n.href = a.href; }
      else { n = document.createElement('button'); n.type = 'button'; n.addEventListener('click', function () { a.onClick(); hideToast(); }); }
      n.textContent = a.label;
      el.appendChild(n);
    });
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5200);
  }
  function hideToast() {
    var el = $('#ee-toast');
    if (!el) return;
    el.classList.remove('is-on');
    setTimeout(function () { el.hidden = true; }, 250);
  }
  function viewLink() { return { label: 'View saved (' + load().length + ')', href: CFG.savedUrl }; }
  function pop(btn) { if (!btn) return; btn.classList.remove('ee-pop'); void btn.offsetWidth; btn.classList.add('ee-pop'); }

  /* ---------------- Live Product Options reading ---------------- */
  var lpo = { customized: false };

  function productForm() {
    var forms = $$('form[action*="/cart/add"]').filter(function (f) { var fid = f.getAttribute('id') || ''; return !!f.querySelector('[name="id"]') && fid.indexOf('product-form') === 0; });
    return forms[0] || null;
  }
  function optLabel(o) {
    var own = null;
    for (var i = 0; i < o.children.length; i++) {
      if (o.children[i].classList && o.children[i].classList.contains('cl-po--label')) { own = o.children[i]; break; }
    }
    var txt = (own ? own.textContent : (o.getAttribute('data-option') || '')).replace(/\s+/g, ' ').trim();
    txt = txt.replace(/\(optional\)/i, '').replace(/^choose\s+/i, '').replace(/[*:]/g, '').trim();
    if (/^measurement$/i.test(txt)) txt = 'Size';
    if (!txt || /^custom_group$/i.test(txt)) txt = (o.getAttribute('data-option') || '').trim();
    if (/^custom_group$/i.test(txt)) txt = '';
    return txt;
  }
  function cleanVal(input) {
    var v = (input.value || '').trim();
    if (/^v_/.test(input.name || '')) v = v.replace(/-\d+$/, '');
    v = v.replace(/\s*\(\+[^)]*\)\s*$/, '').replace(/【[^】]*】/g, '').replace(/\s+/g, ' ').trim();
    return v;
  }
  function readConfig() {
    var w = $('.cl-po--wrapper');
    if (!w) return null;
    var fields = [], raw = [];
    $$('.cl-po--option', w).forEach(function (o) {
      if (!visible(o)) return;
      if (o.parentElement && o.parentElement.closest('.cl-po--option')) return; // nested groups are read by their parent
      var label = optLabel(o), vals = [];
      $$('input[type="radio"]:checked, input[type="checkbox"]:checked', o).forEach(function (i) {
        if (i.name === 'unit_toggle') return;
        var v = cleanVal(i);
        if (v && !/^(no|none)$/i.test(v)) vals.push(v);
      });
      var tv = [];
      $$('input[type="text"], input[type="number"], textarea', o).forEach(function (i) { if (i.value && visible(i)) tv.push(i.value.trim()); });
      if (tv.length) {
        var unit = $('input[name="unit_toggle"]:checked', o);
        vals.push(tv.join(' × ') + (unit && tv.length > 1 ? ' ' + unit.value : ''));
      }
      $$('select', o).forEach(function (s) { if (s.value && visible(s)) vals.push(s.options[s.selectedIndex].text.replace(/\s*\(\+[^)]*\)\s*$/, '').trim()); });
      if (vals.length && label) fields.push({ l: label, v: vals.join(', ') });
    });
    $$('input, select, textarea', w).forEach(function (i) {
      if (i.type === 'hidden' || i.type === 'file' || (!i.name && !i.id)) return;
      if (i.type === 'radio' || i.type === 'checkbox') { if (i.checked) raw.push({ k: 'c', n: i.name, id: i.id, v: i.value }); }
      else if (i.value) raw.push({ k: 'v', n: i.name, id: i.id, v: i.value });
    });
    var f = productForm();
    var idInput = f && f.querySelector('[name="id"]');
    var priceEl = $('.product__info-container .price--on-sale .price-item--sale') || $('.product__info-container .price__regular .price-item--regular');
    return { fields: fields, raw: raw, variantId: idInput ? idInput.value : null, price: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '' };
  }
  function sigOf(cfg) { return cfg && cfg.fields.length ? cfg.fields.map(function (x) { return x.l + '=' + x.v; }).join('|') : ''; }
  function colorOf(cfg) {
    if (!cfg) return '';
    var f = cfg.fields.filter(function (x) { return /colou?r/i.test(x.l); })[0];
    return f ? f.v : '';
  }

  function watchCustomization() {
    waitFor('.cl-po--wrapper', 25000).then(function (w) {
      if (!w) return;
      ['change', 'input', 'click'].forEach(function (ev) {
        w.addEventListener(ev, function (e) { if (e.isTrusted && e.target.closest('input,select,textarea,label,.cl-po--swatch-item,.cl-po--radio-item')) lpo.customized = true; }, true);
      });
    });
  }

  function applyRaw(raw) {
    var w = $('.cl-po--wrapper');
    if (!w) return Promise.resolve(false);
    function find(r) {
      var el = r.id ? document.getElementById(r.id) : null;
      if (el && (el.name === r.n) && (r.k === 'v' || el.value === r.v)) return el;
      var cands = $$('[name="' + (r.n || '').replace(/"/g, '\\"') + '"]', w);
      if (r.k === 'c') return cands.filter(function (c) { return c.value === r.v; })[0] || null;
      return cands[0] || null;
    }
    function setVal(el, v) {
      var proto = el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      var setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
      setter.call(el, v);
      ['input', 'change', 'keyup', 'blur'].forEach(function (t) { el.dispatchEvent(new Event(t, { bubbles: true })); });
    }
    function pass() {
      return raw.reduce(function (p, r) {
        return p.then(function () {
          var el = find(r);
          if (!el) return;
          if (r.k === 'c') { if (!el.checked) el.click(); }
          else if (el.value !== r.v) setVal(el, r.v);
          return delay(120);
        });
      }, Promise.resolve());
    }
    // two passes: conditional groups only appear after earlier choices
    return pass().then(function () { return delay(700); }).then(pass).then(function () { return true; });
  }

  /* ---------------- product page ---------------- */
  function initProductPage() {
    var p = CFG.product;
    if (!p || p.handle === CFG.swatchHandle) return;
    watchCustomization();

    var titleEl = $('.product__info-container .product__title');
    if (titleEl && !$('.ee-heart--title')) {
      var row = document.createElement('div');
      row.className = 'ee-title-row';
      titleEl.parentNode.insertBefore(row, titleEl);
      row.appendChild(titleEl);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ee-heart ee-heart--title';
      b.setAttribute('data-ee-heart', '');
      b.setAttribute('data-handle', p.handle);
      b.setAttribute('aria-label', 'Save ' + p.title);
      b.innerHTML = HEART;
      b.addEventListener('click', function () { productToggle(b); });
      row.appendChild(b);
    }
    var buttons = $('.product__info-container .product-form__buttons');
    if (buttons && !$('.ee-save-design')) {
      var s = document.createElement('button');
      s.type = 'button';
      s.className = 'ee-save-design';
      s.setAttribute('data-ee-heart', '');
      s.setAttribute('data-handle', p.handle);
      s.innerHTML = HEART + '<span>Save this design for later</span>';
      s.addEventListener('click', function () { productToggle(s, true); });
      buttons.parentNode.insertBefore(s, buttons.nextSibling);
    }
    syncHearts();

    // ?ee_design=<id> → restore a saved design
    var m = location.search.match(/[?&]ee_design=([^&]+)/);
    if (m) {
      var it = load().filter(function (i) { return i.id === decodeURIComponent(m[1]); })[0];
      if (it && it.config && it.config.raw && it.config.raw.length) {
        waitFor('.cl-po--wrapper .cl-po--option', 25000)
          .then(function (el) { return el ? delay(2500) : null; })
          .then(function () { return applyRaw(it.config.raw); })
          .then(function (ok) {
            if (!ok) return;
            lpo.customized = true;
            toast('We’ve restored your saved design.<small>Please double-check sizes before adding to cart.</small>');
            track('ee_saved_restore', { handle: it.handle });
          });
      }
    }
  }

  function baseItem(p) {
    return { id: uid(), handle: p.handle, title: p.title, url: p.url, image: p.image || '', price: stripTags(p.price), type: p.type || '', savedAt: Date.now(), sig: '', config: null };
  }

  function productToggle(btn, fromDesignBtn) {
    var p = CFG.product;
    var existing = byHandle(p.handle);
    var cfg = (lpo.customized || fromDesignBtn) ? readConfig() : null;
    var sig = sigOf(cfg);

    if (sig && (lpo.customized || fromDesignBtn)) {
      var same = existing.filter(function (i) { return i.sig === sig; });
      if (same.length) { removeWithUndo(function (i) { return i.sig === sig && i.handle === p.handle; }, 'Design removed from your saved list.'); pop(btn); return; }
      var item = baseItem(p);
      item.sig = sig;
      item.config = { fields: cfg.fields, raw: cfg.raw, variantId: cfg.variantId, price: cfg.price };
      addItem(item);
      pop(btn);
      var summary = cfg.fields.slice(0, 3).map(function (f) { return esc(f.v); }).join(' · ');
      toast((existing.some(function (i) { return i.sig; }) ? 'Saved another design.' : 'Saved with your selections.') + (summary ? '<small>' + summary + '</small>' : ''), [viewLink()]);
      return;
    }
    if (existing.length) {
      removeWithUndo(function (i) { return i.handle === p.handle; }, existing.length > 1 ? 'Removed ' + existing.length + ' saved designs.' : 'Removed from your saved list.');
    } else {
      addItem(baseItem(p));
      toast('Saved to your list.<small>Tip: choose your options first to save the full design.</small>', [viewLink()]);
    }
    pop(btn);
  }

  function removeWithUndo(fn, msg) {
    var removed = removeWhere(fn);
    track('ee_saved_remove', { count: removed.length });
    toast(esc(msg), [{ label: 'Undo', onClick: function () { restoreItems(removed); } }]);
  }

  /* ---------------- product cards + header ---------------- */
  function stripTags(h) { if (!h) return ''; var d = new DOMParser().parseFromString(String(h), 'text/html'); return (d.body.textContent || '').replace(/\s+/g, ' ').trim(); }
  function decorateCards() {
    $$('.card-wrapper').forEach(function (cw) {
      if (cw.querySelector('.ee-heart--card')) return;
      var inner = cw.querySelector('.card__inner');
      var a = cw.querySelector('.card__heading a[href*="/products/"]') || cw.querySelector('a[href*="/products/"]');
      if (!inner || !a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = decodeURIComponent(m[1]);
      if (handle === CFG.swatchHandle) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ee-heart ee-heart--card';
      b.setAttribute('data-ee-heart', '');
      b.setAttribute('data-handle', handle);
      b.setAttribute('aria-label', 'Save ' + a.textContent.trim());
      b.innerHTML = HEART;
      cw.appendChild(b); // not inside .card__inner: its hover transform would put the card link on top
    });
    syncHearts();
  }
  function cardData(b) {
    var cw = b.closest('.card-wrapper');
    var a = cw.querySelector('.card__heading a[href*="/products/"]') || cw.querySelector('a[href*="/products/"]');
    var img = cw.querySelector('.card__media img');
    var src = img ? (img.currentSrc || img.src || '') : '';
    if (src) src = src.replace(/([?&]width=)\d+/, '$1600');
    var priceEl = cw.querySelector('.price--on-sale .price-item--sale') || cw.querySelector('.price__regular .price-item--regular') || cw.querySelector('.price-item');
    var url = (a.getAttribute('href') || '').split('?')[0];
    return { title: a.textContent.replace(/\s+/g, ' ').trim(), url: url, image: src, price: priceEl ? stripTags(priceEl.innerHTML) : '' };
  }
  function fixHeaderLink() {
    $$('a.swym-wishlist, a[href="#swym-wishlist"]').forEach(function (a) {
      a.setAttribute('href', CFG.savedUrl);
      a.classList.remove('swym-wishlist');
      a.classList.add('ee-saved-link');
      a.setAttribute('aria-label', 'Saved items');
      if (!a.querySelector('.ee-saved-count')) { var s = document.createElement('span'); s.className = 'ee-saved-count'; s.hidden = true; a.appendChild(s); }
    });
    updateCount();
  }
  function initCards() {
    decorateCards();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.ee-heart--card[data-ee-heart]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var h = b.getAttribute('data-handle');
      if (byHandle(h).length) {
        removeWithUndo(function (i) { return i.handle === h; }, 'Removed from your saved list.');
      } else {
        var d = cardData(b);
        addItem({ id: uid(), handle: h, title: d.title, url: d.url, image: d.image, price: d.price, type: '', savedAt: Date.now(), sig: '', config: null });
        toast('Saved to your list.', [viewLink()]);
      }
      pop(b);
    }, true);
  }

  /* ---------------- saved page ---------------- */
  var dataCache = {};
  function fetchData(handle) {
    if (dataCache[handle]) return dataCache[handle];
    dataCache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=ee-data', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); })
      .catch(function () { return null; });
    return dataCache[handle];
  }

  function initSavedPage() {
    var app = $('#ee-saved');
    if (!app) return;
    var grid = $('#ee-saved-grid', app), empty = $('#ee-saved-empty', app), bar = $('#ee-cmpbar', app);
    var cmpBox = $('#ee-compare', app), table = $('#ee-compare-table', app);
    var selected = [];
    try { selected = JSON.parse(sessionStorage.getItem('ee_cmp_sel') || '[]'); } catch (e) {}

    function keepSel() {
      var ids = load().map(function (i) { return i.id; });
      selected = selected.filter(function (id) { return ids.indexOf(id) > -1; }).slice(0, MAX_CMP);
      try { sessionStorage.setItem('ee_cmp_sel', JSON.stringify(selected)); } catch (e) {}
    }

    function priceLine(i) {
      if (i.config && i.config.price) return '<div class="ee-item__price">Your design: ' + esc(i.config.price) + '</div>';
      return i.price ? '<div class="ee-item__price">From ' + esc(i.price) + '</div>' : '';
    }
    function render() {
      var list = load();
      keepSel();
      empty.hidden = list.length > 0;
      grid.hidden = list.length === 0;
      grid.innerHTML = list.map(function (i) {
        var sel = selected.indexOf(i.id) > -1;
        var goUrl = i.url + (i.config && i.config.raw && i.config.raw.length ? (i.url.indexOf('?') > -1 ? '&' : '?') + 'ee_design=' + encodeURIComponent(i.id) : '');
        var cfg = i.config && i.config.fields.length
          ? '<ul class="ee-item__cfg">' + i.config.fields.slice(0, 6).map(function (f) { return '<li><b>' + esc(f.l) + ':</b><span>' + esc(f.v) + '</span></li>'; }).join('') + '</ul>'
          : '';
        return '<article class="ee-item' + (sel ? ' is-selected' : '') + '" data-id="' + esc(i.id) + '">' +
          '<button type="button" class="ee-item__rm" data-rm aria-label="Remove ' + esc(i.title) + '">&times;</button>' +
          '<a class="ee-item__img" href="' + esc(goUrl) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy" width="600" height="600">' : '') + '</a>' +
          '<div class="ee-item__body">' +
            (i.config ? '<span class="ee-item__tag">Your design</span>' : '') +
            '<h3 class="ee-item__title"><a href="' + esc(goUrl) + '">' + esc(i.title) + '</a></h3>' +
            priceLine(i) +
            cfg +
            '<div class="ee-item__actions">' +
              '<label class="ee-item__cmp"><input type="checkbox" data-cmp' + (sel ? ' checked' : '') + '> Compare</label>' +
              '<a class="ee-item__go" href="' + esc(goUrl) + '">' + (i.config ? 'Continue this design' : 'Choose options') + ' &rarr;</a>' +
            '</div>' +
          '</div>' +
        '</article>';
      }).join('');
      updateBar();
      if (!cmpBox.hidden) renderCompare();
    }

    function updateBar() {
      var n = selected.length;
      bar.hidden = load().length < 2;
      $('b', bar).textContent = n;
      $('#ee-cmp-go', bar).disabled = n < 2;
    }

    grid.addEventListener('click', function (e) {
      var card = e.target.closest('.ee-item');
      if (!card) return;
      var id = card.getAttribute('data-id');
      if (e.target.closest('[data-rm]')) {
        removeWithUndo(function (i) { return i.id === id; }, 'Removed from your saved list.');
        return;
      }
    });
    grid.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-cmp]');
      if (!cb) return;
      var id = cb.closest('.ee-item').getAttribute('data-id');
      if (cb.checked) {
        if (selected.length >= MAX_CMP) { cb.checked = false; toast('You can compare up to ' + MAX_CMP + ' items at a time.'); return; }
        selected.push(id);
      } else {
        selected = selected.filter(function (x) { return x !== id; });
      }
      keepSel();
      cb.closest('.ee-item').classList.toggle('is-selected', cb.checked);
      updateBar();
      if (!cmpBox.hidden) { if (selected.length >= 2) renderCompare(); else cmpBox.hidden = true; }
    });
    $('#ee-cmp-go', bar).addEventListener('click', function () {
      cmpBox.hidden = false;
      renderCompare();
      cmpBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      track('ee_compare_open', { count: selected.length });
    });
    $('[data-cmp-clear]', bar).addEventListener('click', function () {
      selected = []; keepSel(); cmpBox.hidden = true; render();
    });
    $('[data-cmp-close]', cmpBox).addEventListener('click', function () { cmpBox.hidden = true; });
    $('#ee-diff', cmpBox).addEventListener('change', function (e) { table.classList.toggle('ee-hide-same', e.target.checked); });

    var renderToken = 0;
    function renderCompare() {
      var items = load().filter(function (i) { return selected.indexOf(i.id) > -1; });
      items.sort(function (a, b) { return selected.indexOf(a.id) - selected.indexOf(b.id); });
      if (items.length < 2) { cmpBox.hidden = true; return; }
      var token = ++renderToken;
      table.style.setProperty('--ee-cols', items.length);
      table.innerHTML = '<tbody><tr><td class="ee-compare__loading">Loading details&hellip;</td></tr></tbody>';
      Promise.all(items.map(function (i) { return fetchData(i.handle); })).then(function (datas) {
        if (token !== renderToken) return;
        // union of spec rows in first-seen order
        var order = [], labels = {};
        datas.forEach(function (d) { (d && d.specs || []).forEach(function (s) { if (!labels[s.k]) { labels[s.k] = s.l; order.push(s.k); } }); });
        var head = '<thead><tr><th scope="col"><span class="visually-hidden">Feature</span></th>' + items.map(function (i, idx) {
          var d = datas[idx] || {};
          var goUrl = i.url + (i.config && i.config.raw && i.config.raw.length ? (i.url.indexOf('?') > -1 ? '&' : '?') + 'ee_design=' + encodeURIComponent(i.id) : '');
          return '<th scope="col"><div class="ee-ct__prod">' +
            (i.image || d.image ? '<img src="' + esc(i.image || d.image) + '" alt="" loading="lazy" width="300" height="300">' : '') +
            '<a href="' + esc(goUrl) + '">' + esc(i.title) + '</a>' +
            '<span class="ee-ct__price">' + (i.config && i.config.price ? 'Your design: ' + esc(i.config.price) : 'From ' + esc(stripTags(d.price) || i.price || '')) + '</span>' +
            '<a class="button button--secondary" href="' + esc(goUrl) + '">' + (i.config ? 'Continue' : 'View') + '</a>' +
          '</div></th>';
        }).join('') + '</tr></thead>';

        var rows = [];
        if (items.some(function (i) { return i.config && i.config.fields.length; })) {
          rows.push({ label: 'Your selections', cells: items.map(function (i) {
            return i.config && i.config.fields.length ? '<ul class="ee-ct__cfg">' + i.config.fields.map(function (f) { return '<li><b>' + esc(f.l) + ':</b> ' + esc(f.v) + '</li>'; }).join('') + '</ul>' : '';
          }), raw: items.map(function (i) { return sigOf(i.config); }), always: true });
        }
        if (datas.some(function (d) { return d && d.rating; })) {
          rows.push({ label: 'Rating', cells: datas.map(function (d) { return d && d.rating ? esc(Number(d.rating).toFixed(1)) + ' / 5' + (d.ratingCount ? ' <span style="opacity:.7">(' + esc(d.ratingCount) + ' reviews)</span>' : '') : ''; }), raw: datas.map(function (d) { return d && d.rating; }) });
        }
        order.forEach(function (k) {
          var vals = datas.map(function (d) { var s = d && (d.specs || []).filter(function (x) { return x.k === k; })[0]; return s ? s.v : ''; });
          rows.push({ label: labels[k], cells: vals.map(esc), raw: vals });
        });
        var body = '<tbody>' + rows.map(function (r) {
          var filled = r.raw.filter(function (x) { return x; }).map(function (x) { return String(x).split(/\s*,\s*/).sort().join(','); });
          var same = !r.always && filled.length === r.raw.length && filled.every(function (x) { return x === filled[0]; });
          return '<tr class="' + (same ? 'is-same' : 'is-diff') + '"><th scope="row">' + esc(r.label) + '</th>' +
            r.cells.map(function (c) { return '<td' + (c ? '' : ' class="is-empty"') + '>' + (c || '&mdash;') + '</td>'; }).join('') + '</tr>';
        }).join('') + '</tbody>';
        table.innerHTML = head + body;
      });
    }

    /* help block */
    function helpItems() {
      var list = load();
      var chosen = list.filter(function (i) { return selected.indexOf(i.id) > -1; });
      return chosen.length ? chosen : list;
    }
    function describe(i) {
      var s = i.title;
      if (i.config && i.config.fields.length) s += ' (' + i.config.fields.slice(0, 4).map(function (f) { return f.v; }).join(', ') + ')';
      return s;
    }
    var swBtn = $('#ee-help-swatch', app);
    if (swBtn) swBtn.addEventListener('click', function (e) {
      var req = helpItems().filter(function (i) { return !HARDWARE_RE.test(i.type || '') && !HARDWARE_RE.test(i.title || ''); })
        .map(function (i) { return { t: i.title, c: colorOf(i.config), ty: i.type || '' }; });
      try { localStorage.setItem(SW_KEY, JSON.stringify({ at: Date.now(), items: req.slice(0, 12) })); } catch (err) {}
      track('ee_help_swatch', { count: req.length });
      // let the link navigate normally (href already points to the swatch page with ?ee_sw=1)
    });
    function openForm() {
      var box = $('#ee-help-form', app);
      if (!box) return;
      box.hidden = false;
      var body = $('#ee-help-body', box);
      if (body && !body.value) {
        var items = helpItems();
        body.value = (items.length ? 'I’m deciding between:\n' + items.map(function (i) { return '- ' + describe(i); }).join('\n') + '\n\n' : '') +
          'I’d like help choosing. (AI room render / real product photos)';
      }
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var email = $('input[type="email"]', box);
      if (email) setTimeout(function () { email.focus({ preventScroll: true }); }, 400);
    }
    var chatBtn = $('#ee-help-chat', app);
    if (chatBtn) chatBtn.addEventListener('click', function () {
      var items = helpItems();
      var msg = (items.length ? 'Hi! I’m deciding between: ' + items.map(describe).join('; ') + '. ' : 'Hi! ') + 'Could you help me choose? I’d love an AI room render or real photos.';
      track('ee_help_designer', { count: items.length });
      var T = window.Tawk_API;
      var online = T && typeof T.getStatus === 'function' && T.getStatus() !== 'offline';
      if (online) {
        try { T.addTags(['saved-compare'], function () {}); } catch (e) {}
        try { T.addEvent('compare-help', { items: items.map(function (i) { return i.title; }).join(' | ').slice(0, 250) }, function () {}); } catch (e) {}
        try { T.maximize(); } catch (e) {}
        setTimeout(function () { try { T.setChatInputMessage(msg.slice(0, 900)); } catch (e) {} }, 700);
      } else {
        openForm();
      }
    });
    var emailBtn = $('#ee-help-email', app);
    if (emailBtn) emailBtn.addEventListener('click', openForm);
    // after a contact-form post the page reloads — keep the form open to show the result
    if ($('#ee-help-form .ee-help__ok, #ee-help-form .ee-help__err', app)) { $('#ee-help-form', app).hidden = false; }

    document.addEventListener('ee:saved-change', render);
    render();
  }

  /* ---------------- free swatch page pre-select ---------------- */
  var GENERIC = /^(curtains?|drapes?|drapery|shades?|blinds?|window|windows|custom|for|the|and|with|of|a|living|room|bedroom|panels?|made|to|measure|new|set|in)$/i;
  var LINES = [
    { re: /shangri|sheer\s+shades?|sheer\s+blinds?|sheer-curtain-panels/i, g: /shangri/i },
    { re: /zebra|day.?and.?night/i, g: /zebra/i },
    { re: /roller|solar/i, g: /^roller/i },
    { re: /honeycomb|cellular|skylight|top.?down|arched|glass.?door|waterproof/i, g: /honeycomb/i },
    { re: /bamboo|woven|jute|ramie/i, g: /bamboo/i },
    { re: /velvet/i, g: /velvet/i },
    { re: /chenille/i, g: /chenille/i },
    { re: /herringbone/i, g: /herringbone/i },
    { re: /ginkgo/i, g: /ginkgo/i },
    { re: /hunter/i, g: /hunter/i },
    { re: /french\s+linen/i, g: /french\s+linen/i },
    { re: /strip/i, g: /strip/i },
    { re: /sheer|voile|net\b/i, g: /^sheer/i }
  ];
  function norm(s) { return String(s || '').toLowerCase().replace(/【[^】]*】|\([^)]*\)/g, ' ').replace(/\b\w*\d\w*\b/g, ' ').replace(/[^a-z\s]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function tokens(s) { return norm(s).split(' ').filter(function (w) { return w.length > 2 && !GENERIC.test(w); }); }

  function initSwatchPrefill() {
    if (!CFG.product || CFG.product.handle !== CFG.swatchHandle) return;
    if (!/[?&]ee_sw=1/.test(location.search)) return;
    var req;
    try { req = JSON.parse(localStorage.getItem(SW_KEY) || 'null'); } catch (e) { req = null; }
    if (!req || !req.items || !req.items.length || Date.now() - req.at > 30 * 60 * 1000) return;

    waitFor('.cl-po--wrapper .cl-po--option input.cl-po--input', 25000)
      .then(function (el) { return el ? delay(6000) : null; })
      .then(function () {
        var w = $('.cl-po--wrapper');
        if (!w) return;
        var groups = $$('.cl-po--option', w).filter(function (o) { return o.getAttribute('data-option'); });
        var picked = [], lines = [], firstHit = null;
        req.items.forEach(function (it) {
          var hay = it.t + ' ' + (it.ty || '');
          var g = null;
          for (var i = 0; i < LINES.length && !g; i++) {
            if (LINES[i].re.test(hay)) g = groups.filter(function (o) { return LINES[i].g.test(o.getAttribute('data-option')); })[0] || null;
          }
          if (!g) {
            var tk = tokens(it.t), best = 0;
            groups.forEach(function (o) {
              var gt = tokens(o.getAttribute('data-option'));
              var score = tk.filter(function (w) { return gt.indexOf(w) > -1; }).length;
              if (score > best) { best = score; g = o; }
            });
          }
          if (!g) return;
          if (!firstHit) firstHit = g;
          g.classList.add('ee-sw-hit');
          var gname = g.getAttribute('data-option');
          var c = norm(it.c);
          var hit = null;
          if (c.length >= 3) {
            hit = $$('input.cl-po--input', g).filter(function (inp) {
              var v = norm(inp.value);
              return v && (v === c || v.indexOf(c) > -1 || c.indexOf(v) > -1);
            })[0] || null;
          }
          if (hit) {
            if (!hit.checked) hit.click();
            picked.push(esc(it.c) + ' <span style="opacity:.7">(' + esc(gname) + ')</span>');
          } else if (lines.indexOf(gname) < 0) {
            lines.push(gname);
          }
        });
        if (!picked.length && !lines.length) return;
        var bn = document.createElement('div');
        bn.className = 'ee-swbanner';
        bn.innerHTML = '<b>From your saved list</b>' +
          (picked.length ? '<br>We pre-selected: ' + picked.join(', ') + '.' : '') +
          (lines.length ? '<br>Pick your colors in the highlighted fabric line' + (lines.length > 1 ? 's' : '') + ': ' + lines.map(esc).join(', ') + '.' : '') +
          '<br><span style="opacity:.75">You can add or remove any swatch below (up to 25).</span>';
        var chips = $('#fsux-chips');
        (chips || w).parentNode.insertBefore(bn, chips || w);
        w.dispatchEvent(new Event('change', { bubbles: true }));
        if (firstHit) setTimeout(function () { bn.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
        track('ee_swatch_prefill', { picked: picked.length, lines: lines.length });
      });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    fixHeaderLink();
    syncHearts();
    initCards();
    initProductPage();
    initSavedPage();
    initSwatchPrefill();
    window.addEventListener('storage', function (e) { if (e.key === KEY) { updateCount(); syncHearts(); document.dispatchEvent(new CustomEvent('ee:saved-change')); } });
    // hearts inside sections loaded later (quick add, recommendations)
    document.addEventListener('shopify:section:load', syncHearts);
    if (window.MutationObserver) {
      var mt;
      new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(decorateCards, 250); }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
